module.exports = __webpack_public_path__ + "static/media/HomeLogoGrey.04fb01f1.svg";